/**** 类型分组+阈值报警(ZH) ****/
export default {
  // 类型分组
  SPACE_GROUP_TITLE: '类型分组',
  ADD_GROUP_NAME_PLACEHOLDER: '请输入组名',
  SPACE_GROUP_DELETED_ERROR: '此分组不可被删除',
  SPACE_GROUP_DELETED_ERROR_TIPS: '当所选分组有类型费率时，不可被删除',

  FORM_GROUP_TITLE: '类型分组',
  FORM_TYPE_NAME: '类型名称',
  FORM_TYPE_PRICE: '费率',

  SPACE_TYPES: '类型费率',
  ADD_SPACE_TYPES: '添加类型费率',
  EDIT_SPACE_TYPES: '编辑类型费率',
  SPACE_TYPE_NAME: '类型名称',
  SPACE_TYPE_RATE_AMOUNT: '费率数额',
  SPACE_TYPE_RATE_UNIT: '费率单位',
  SPACE_TYPES_DELETED_CONFIRM_TIPS: '删除费率后，已应用此类型费率的共享工位的使用费用可能会置空。确定要删除吗？',

  SPACE_TYPE_NAME_INPUT_TIP: '请输入类型名称',
  SPACE_TYPE_RATE: '费率',
  SPACE_TYPE_RATE_INPUT_TIP: '请输入费率值',
  SPACE_TYPES_EIDT_CONFIRM_TIPS: '修改费率后，已应用此类型费率的共享工位的使用费用可能会发生变化。确定要修改吗？',

  FORM_INFPUT_ERROR: '输入错误',
  BATCHES_DELETEL: '批量删除',
  ADD_SIBLING: '添加同级',
  ADD_CHILDREN: '添加子级',
  ITEM_RENAME: '重命名',
  TYPE_UNIT_HOUR: '元/个/小时',
  TYPE_UNIT_DAY: '元/个/天',
  TYPE_UNIT_MONTH: '元/个/月',
  PECUNIARY_UNIT: '元',
  MIDDLE_TIP: '超过',

  // 工位设置部分
  HOT_DESK_SETTING_TYPE_RATE: '设置共享工位类型费率',
  DESK_TYPE_RATE_CONFIRM_TIP: '新的空间类型费率设置会立刻生效，此共享工位的使用费用可能会发生变化。确定要修改吗？',
  DESK_TYPE_RATE_CONFIRM_MULTIPLE_TIP:
    '新的空间类型费率设置会立刻生效，所选共享工位的使用费用可能会发生变化。确定要修改吗？',
  FIXED_DESK_TYPE_CHANGE_CONFIRM_TIP: '系统会自动解绑同时清除原固定工位分配的部门/员工,确认要变更工位属性吗?',
  HOT_DESK_TYPE_CHANGE_CONFIRM_TIP: '系统会自动结束/取消原共享工位未结束的订单,确认要变更工位属性吗?',
  // 实时概览
  BOOKING_OVERVIEW_TITLE: '数据总览',
  OVERVIEW_DESK_USER: '使用工位的员工数',
  OVERVIEW_DESK_AREA: '工位总面积',
  OVERVIEW_AVERAGE_DESK_AREA: '人均工位面积',
  OVERVIEW_DESK_USAGE_RATE: '工位使用率',
  OVERVIEW_DESK_TOTAL_NUM: '工位数量',
  OVERVIEW_DESK_FREE_NUM: '空闲工位数量',
  OVERVIEW_FIXED_DESK_BOOKING_USAGE: '固定工位分配使用情况',
  OVERVIEW_FIXED_DESK_COUNT: '固定工位总数',
  OVERVIEW_HOT_DESK_BOOKING_USAGE: '共享工位预订使用情况',
  OVERVIEW_HOT_DESK_COUNT: '共享工位总数',
  FIXED_DESK_TYPE_VACANCY: '未分配(空闲)',
  FIXED_DESK_TYPE_BIND: '已绑定(使用)',
  FIXED_DESK_TYPE_ALLOT: '已分配',
  HOT_DESK_TYPE_VACANCY: '可预订(空闲)',
  HOT_DESK_TYPE_BUSY: '已签到(使用)',
  HOT_DESK_TYPE_BOOKING: '已预订',
  OVERVIEW_FIXED_USAGE_RATE_TIPS: '固定工位中被绑定使用工位数/固定工位总数',
  OVERVIEW_FIXED_UNUSE_RATE_TIPS: '未分配工位数/固定工位总数【若有报警值则在[ ]内显示】',
  OVERVIEW_HOT_USAGE_RATE_TIPS: '已签到(使用)工位/共享工位总数【若有报警值则在[ ]内显示】',
  OVERVIEW_HOT_UNUSE_RATE_TIPS: '可预订(空闲)工位数/共享工位总数',
  OVERVIEW_DEPARTMENT_USE_RATE_TIPS: '本部门使用工位数/该部门工位数量【若有报警值则在[ ]内显示】',
  // 预定报表
  BOOKING_FORM_TYPES_RATE_INFO: '费用信息',
  BOOKING_FORM_SPACE_TYPES_RATE: '空间类型费率',
  BOOKING_FORM_SPACE_TYPES_RATE_TIP: '即该预订工位预订开始时间所对应的空间类型费率',
  BOOKING_FORM_USAGE_COST: '使用费用',
  BOOKING_FORM_USAGE_COST_TIP:
    '使用费用=空间类型费率*计费时长(计费时长=实际结束时间-预订开始时间)(若计费时长不满半小时按半小时计算，超过半小时按1小时计算)',
  // 阈值报警
  ALARM_VALUE_SETTING: '报警值设置',
  ALARM_DEPARTMENT_LIST: '部门报警值列表',
  ALARM_BUILDING_LIST: '楼宇报警值列表',
  ALARM_VALUE_USAGE_RANGE: '使用范围',
  ALARM_VALUE_TRIGGERS: '报警触发条件',
  ALARM_VALUE_RULE_NAME: '报警通知',
  ALARM_VALUE_USAGE_RANGE_PLACEHOLDER: '请选择适用范围',
  ALARM_VALUE_TRIGGERS_PLACEHOLDER: '请选择报警触发条件',
  ALARM_VALUE_RULE_NAME_PLACEHOLDER: '请输入报警通知规则',
  ALARM_VALUE_TRIGGERS_VALUE_TIPS: '请输入整数百分值',
  ADD_TRIGGER: '新增触发条件',

  ADD_DEPARTMENT_ALARM: '添加部门报警值',
  EDIT_DEPARTMENT_ALARM: '编辑部门报警值',
  DELETED_DEPARTMENT_ALARM_TIPS: '该部门下全部子部门的报警值都会被删除，确定要删除吗？',
  ADD_BUILDING_ALARM: '添加楼宇报警值',
  EDIT_BUILDING_ALARM: '编辑楼宇报警值',
  DELETED_BUILDING_ALARM_TIPS: '该地区(楼宇)下全部楼层的报警值都会被删除，确定要删除吗？',

  ALARM_NOTIFY_SETTING: '报警通知设置',
  ADD_ALARM_NOTIFY_RULE: '添加报警通知规则',
  DELETED_ALARM_NOTIFY_RULE: '确定要删除 【{name}】 吗?',
  DELETED_ALARM_NOTIFY_RULE_TIPS: '删除后，应用该规则的报警设置则遵守【{name}】',
  EDIT_ALARM_NOTIFY_RULE: '编辑报警通知规则',
  ALARM_NOTIFY_RULE: '自定义报警通知规则',
  ALARM_NOTIFY_RULE_NAME_PLACEHOLDER: '请输入规则名称',
  ALARM_NOTIFY_RULE_NAME_TIPS: '*注：已应用的通知规则在添加新的接收人后，只会接收到添加时刻之后发送的通知',
  ALARM_NOTIFY_RULE_FREQUENCY: '通知频率',
  ALARM_NOTIFY_RULE_ROLES_FORM: '通知接收人',
  ALARM_NOTIFY_RULE_ROLES: '通知人',
  ALARM_NOTIFY_RULE_CONTENT: '通知内容',
  ALARM_NOTIFY_RULE_CONTENT_PLACEHOLDER: '请输入通知内容',
  ALARM_NOTIFY_FREQUENCY_TEXT: '达到报警触发条件后仅报警一次',
  ALARM_FIXED_DESK_USAGE_RATE: '固定工位使用率',
  ALARM_FIXED_DESK_USAGE_RATE_OVER: '固定工位使用率超过',
  ALARM_FIXED_DESK_VACANT_RATE: '固定工位空置率',
  ALARM_FIXED_DESK_VACANT_RATE_OVER: '固定工位空置率超过',
  ALARM_HOT_DESK_USAGE_RATE: '共享工位使用率',
  ALARM_HOT_DESK_USAGE_RATE_OVER: '共享工位使用率超过',
  HANDLE_CURRENT_NOTIFY: '处理通知',
  HANDLE: '处理',
  HANDLE_SUCCESS: '处理成功',
  NOTIFY_HANDLER: '处理人',
  NOTIFY_HANDLE_TIME: '处理时间',
  NOTIFY_TIME: '通知时间',
  NOTIFY_ALARM_TRIGGER_VAL: '报警触发值',
  NOTIFY_USAGE_RANGE: '报警适用范围',
  NOTIFY_TYPE: '报警值类型',
  NOTIFY_HANDLER_PLACEHOLDER: '请输入处理人',
  NOTIFY_HANDLER_INPUT_ERROR: '最多选择10个处理人',
  ALARM_NOTIFY_DETAIL: '报警通知详情',
  HANDLE_DETAIL: '处理详情',
  LIST_SEARCH_PLACEHOLDER: '搜索: 适用范围',

  NOTIFY_FOR_BUILDINGS: '楼宇阈值报警',
  NOTIFY_FOR_DEPARTMENTS: '部门阈值报警',
}
